import { useAxios } from "./apiHelper";
export const useApiStock = () => {
  const httpRequest = useAxios();
  return {
    getDetailStockTPRL: (jsonData) => {
      // const formData = new FormData();
      // formData.append("pSymbol", jsonData.pSymbol);
      // formData.append("pFromDate", jsonData.pFromDate);
      // formData.append("pToDate", jsonData.pToDate);
      return httpRequest.get("/api/cbts/get-detail-stock", {
        params: jsonData
      });
    },
    getHistStockTPRL: (jsonData) => {
      return httpRequest.get("/api/cbts/get-stock-hist", {
        params: jsonData
      });
    },
  };
};
